export const ArrowLeft = () => {
  return (
    <>
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.386 11.613l-3.453 3.453c-0.124 0.123-0.222 0.27-0.289 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.347 0.101 0.509s0.165 0.308 0.289 0.431l3.453 3.453c0.84 0.84 2.28 0.24 2.28-0.947v-6.907c0-1.187-1.44-1.773-2.28-0.933z"></path>
      </svg>
    </>
  );
};

export const ArrowRight = () => {
  return (
    <>
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.613 20.387l3.453-3.453c0.124-0.123 0.222-0.27 0.289-0.431s0.101-0.334 0.101-0.509-0.034-0.347-0.101-0.509c-0.067-0.161-0.165-0.308-0.289-0.431l-3.453-3.453c-0.84-0.827-2.28-0.24-2.28 0.947v6.893c0 1.2 1.44 1.787 2.28 0.947z"></path>
      </svg>
    </>
  );
};
